import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pasoService } from '../services/pasoService';
import { FormularioEvaluacion, PasoParamsInput } from '../types/paso';

export function usePasos(enabled = true) {
  return useQuery({ queryKey: ['pasos'], queryFn: pasoService.list, enabled });
}

export function useUpdatePaso() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: PasoParamsInput }) => pasoService.updateParams(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pasos'] }),
  });
}

export function useGuardarFormulario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, formulario }: { id: number; formulario: FormularioEvaluacion }) =>
      pasoService.guardarFormulario(id, formulario),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pasos'] }),
  });
}

export function usePoblarPaso() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: pasoService.poblar,
    onSuccess: (data) => {
      // Solo al confirmar (commit) se crean instancias: refresca lo que las lista
      // y el propio paso, que trae la fecha de esta actualización.
      if (data.publicado) {
        qc.invalidateQueries({ queryKey: ['instancias'] });
        qc.invalidateQueries({ queryKey: ['estudiantes'] });
        qc.invalidateQueries({ queryKey: ['pasos'] });
      }
    },
  });
}

/** Procesos de un paso y cohorte, para el diálogo de mover. */
export function useCandidatosAMover(paso: number | '', ano: number, semestre: number, enabled: boolean) {
  return useQuery({
    queryKey: ['candidatos-mover', paso, ano, semestre],
    queryFn: () => pasoService.candidatosAMover(paso as number, ano, semestre),
    enabled: enabled && paso !== '',
  });
}

/** Mueve procesos a otro paso; al confirmar refresca lo que los lista. */
export function useMoverEstudiantes() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: pasoService.mover,
    onSuccess: (data) => {
      if (data.publicado) {
        qc.invalidateQueries({ queryKey: ['instancias'] });
        qc.invalidateQueries({ queryKey: ['estudiantes'] });
        qc.invalidateQueries({ queryKey: ['candidatos-mover'] });
      }
    },
  });
}
